"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const DatahubService_1 = __importDefault(require("modules/app/services/datahub/DatahubService"));
class ReviewService {
    constructor() {
        this.save = (reviewSubject, { rating, comment }) => {
            DatahubService_1.default.sendMetrify({
                group: `Review:${reviewSubject}`,
                name: rating.toString(),
                params: { comment }
            });
        };
    }
}
exports.default = new ReviewService();
